import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { authHeaders } from '../actions';

const fetchResultsEmailSendout = async (surveyId) => {
  const response = await axios.get(
    `/api/dashboard/asq_surveys/${surveyId}/results_parent_email_sendout`,
    { headers: authHeaders() }
  );
  return response.data;
};

const enqueueResultsEmailSendout = async (surveyId) => {
  const response = await axios.post(
    `/api/dashboard/asq_surveys/${surveyId}/results_parent_email_sendout`,
    {},
    { headers: authHeaders() }
  );
  return response.data;
};

export const useAsqResultsEmailSendout = (surveyId) => {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: ['asqResultsEmailSendout', surveyId],
    queryFn: () => fetchResultsEmailSendout(surveyId),
    enabled: false,
  });

  const mutation = useMutation({
    mutationFn: () => enqueueResultsEmailSendout(surveyId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['asqResultsEmailSendout', surveyId] });
    },
  });

  return {
    sendoutData: query.data,
    isLoadingSendouts: query.isLoading && query.fetchStatus !== 'idle',
    refetchSendouts: query.refetch,
    enqueueEmail: mutation.mutate,
    isEnqueuing: mutation.isPending,
  };
};
